import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import Typography from "material-ui/Typography";


import Link from '../';

import { withStyles } from 'material-ui/styles';

const styles = theme => {

  const {
    palette: {
      // background: {
      // },
      primary,
      // grey,
      getContrastText,
    },
  } = theme;

  // const backgroundColor = primary[500];
  const backgroundColor = "#39a71f";
  const color = getContrastText(backgroundColor);

  // const backgroundColorHover = "#39a71f";
  const backgroundColorHover = primary[500];
  const colorHover = getContrastText(backgroundColorHover);

  return {
    root: {
    },
    text: {

      "&.button": {
        fontSize: "0.8rem",
        display: "inline-block",
        backgroundColor,
        color,
        borderRadius: 3,
        margin: 3,
        padding: "1px 3px",

        "&:hover": {
          backgroundColor: backgroundColorHover,
          color: colorHover,
        },

        "&.nowrap": {
          whiteSpace: "nowrap",
        },
      },

    },
  }
};


export class BlogLink extends Component {


  static propTypes = {
    variant: PropTypes.string,
  };


  static defaultProps = {

  }


  render() {

    const {
      object,
      children,
      classes,
      variant,
      ...other
    } = this.props;


    if (!object) {
      return null;
    }

    let {
      id,
      uri,
      name,
      longtitle,
    } = object;


    if (!id) {
      return null;
    }

    name = name || id;

    return <Link
      to={uri}
      title={longtitle || name}
      classes={classes}
      textClassName={[variant, name.length < 25 ? "nowrap" : ""].join(" ")}
      {...other}
    >
      {children || name}
    </Link>
  }
}


export default withStyles(styles)(BlogLink);